// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dashboard-worker[data-v-5369b637] {
  display: inline-block;
  height: 53px;
  width: 53px;
}
.dashboard-worker img[data-v-5369b637] {
  max-width: 100%;
  border: 3px solid;
  border-radius: 50%;
  width: 100%;
}
.status-outline-normal img[data-v-5369b637] {
  border-color: #4caf50;
}
.status-outline-critical img[data-v-5369b637] {
  border-color: #f44336;
}
.status-outline-warning img[data-v-5369b637] {
  border-color: #ff9800;
}
.dashboard-worker.offline img[data-v-5369b637] { /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.oncall-person[data-v-5369b637] {
  position: relative;
  display: inline-block;
}
.oncall-person .call-icon[data-v-5369b637] {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 5px;
  top: 0px;
  display: inline-block;
  text-align: center;
  background-color: rgba(76, 175, 80, 0.7);
  border-radius: 50%;
  color: #fff;
  padding: 18px 0px;
}
.oncall-person .call-icon i[data-v-5369b637] {
  color: #fff;
}
.call-badge-content[data-v-5369b637] {
  position: relative;
  display: inline-block;
}
.teaminfo[data-v-5369b637] {
  display: inline-block;
  max-height: 55px;
  max-width: 55px;
}
.offline-user[data-v-5369b637] {
  display: inline-block;
}
.offline-user .showoffline-user[data-v-5369b637] {
  height: 53px;
  width: 53px;
  display: inline-block;
  background-color: rgba(199, 199, 199, 0.5);
  border-radius: 50%;
  border: 2px solid #939393;
  top: -6px;
  padding: 10px 0px;
  cursor: pointer;
  transition: 0.3s all linear;
}
.offline-user .showoffline-user[data-v-5369b637]:hover {
  border: 2px solid #565555;
}
.offline-user .showoffline-user i[data-v-5369b637] {
  font-size: 30px;
}
.offline-user .showoffline-user .count[data-v-5369b637] {
  font-size: 22px;
  font-weight: 600;
  color: #7b7979;
  display: inline-block;
  margin-top: 5px;
  cursor: pointer;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
